import { z } from "zod";
import { MessageSchema } from "./Message";

export type QcUnreadMessage = z.infer<typeof QcUnreadMessageSchema>;
export const QcUnreadMessageSchema = z.object({
  conversation_id: z.string(),
  created_at: z.string(),
  id: z.number(),
  message: MessageSchema,
  message_id: z.string(),
  notification_at: z.string(),
  notification_count: z.number(),
  notification_type: z.string(),
  role: z.string(),
  send_user_id_account: z.number(),
  unread_user_id_account: z.number(),
  updated_at: z.string(),
});
